import { render, staticRenderFns } from "./DetalleMovimiento.vue?vue&type=template&id=1c6e9e75&scoped=true"
import script from "./DetalleMovimiento.vue?vue&type=script&lang=js"
export * from "./DetalleMovimiento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6e9e75",
  null
  
)

export default component.exports